import { appDefaults }    from './../../defaults'
import { http }           from '@/http'
import GeolocationHandler from './../GeolocationHandler'

const API_RESOURCE_USER                    = 'User'
const API_RESOURCE_USERS                   = 'User/GetPaged'
const API_RESOURCE_USER_ENTITY_DEFINITIONS = 'User/GetEntityDefinition'
const API_RESOURCE_USER_BASE_ENTITIES      = 'User/GetUserBaseEntities'
const API_RESOURCE_USER_PARAMS             = 'User/GetUserParams'

export default new class User {

  /**
   *
   * @param defaults
   */
  constructor (defaults) {
    if (!defaults) {
      defaults = appDefaults
    }

    this.limit  = defaults.api.limit
    this.offset = defaults.api.offset
    this.where  = ''

    this.userParams = null

    this.geolocationHandler = GeolocationHandler
  }

  /**
   *
   * @returns {{limit: number|*, offset: number|*}}
   */
  defaults () {
    return {
      limit:  this.limit,
      offset: this.offset
    }
  }

  /**
   *
   * @param args
   * @param successCallback
   * @param errorCallback
   */
  getEntityDefinitions (args, successCallback, errorCallback) {
    return this
      .geolocationHandler
      .getPromise()
      .then(() => {
        this
          .geolocationHandler
          .extendArgs(args)

        return http
          .get(API_RESOURCE_USER_ENTITY_DEFINITIONS, {
            params: args
          })
          .then(response => {
            let parsedFieldsData = response.data[0]

            successCallback(response, parsedFieldsData, parsedFieldsData)
          })
          .catch(error => {
            errorCallback(error)
          })
      })
  }

  /**
   *
   * @param successCallback
   * @param errorCallback
   * @return {Promise<any>}
   */
  getUserBaseEntities (successCallback, errorCallback) {
    return this
      .geolocationHandler
      .getPromise()
      .then(() => {
        let args = {}
        this
          .geolocationHandler
          .extendArgs(args)

        return http
          .get(API_RESOURCE_USER_BASE_ENTITIES, {
            params: args
          })
          .then(response => {
            let parsedFieldsData = response.data

            successCallback(response, parsedFieldsData)
          })
          .catch(error => {
            errorCallback(error)
          })
      })
  }

  /**
   *
   * @param success
   * @param error
   * @param enforce
   * @return {*}
   */
  getUserParams (success, error, enforce = false) {
    if (this.userParams && !enforce) {
      return success(this.userParams)
    }

    return this
      .geolocationHandler
      .getPromise()
      .then(() => {
        let args = {}
        this
          .geolocationHandler
          .extendArgs(args)

        return http
          .get(API_RESOURCE_USER_PARAMS, {
            params: args
          })
          .then(response => {
            this.userParams = response.data[0]

            success(this.userParams)
          })
          .catch(response => {
            error(response)
          })
      })
  }

  /**
   *
   * @param args
   * @return {*}
   */
  find (args) {
    args = $.extend(true, {}, this.defaults, args)

    let params = {
      pageSize: args.limit,
      pageNum:  args.offset,
      where:    this._where(args.query) // @TODO: tohle je bezpecnostni dira!!!
    }

    return http.get(API_RESOURCE_USERS, {
      params: params
    })
  }

  /**
   *
   * @param id
   * @return {*}
   */
  delete (id) {
    return http.delete(API_RESOURCE_USER + '/' + id)
  }

  /**
   *
   * @TODO: toto by nemelo fungovat -> SQL Injection! nemuzu posilat primo cast
   *   sql !! api by tohle melo escapovat a spravne by to nemelo fungovat!
   * @param query
   * @return {string}
   * @private
   */
  _where (query) {
    if (!query) {
      query = this.where
    }

    return 'email like \'%' + query + '%\' OR FirstName like \'%' + query +
      '%\' OR LastName like \'%' + query + '%\''
  }

}
